import { accordionAnatomy as parts } from "@chakra-ui/anatomy";
export { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, useAccordionItemState, useAccordionContext } from "@chakra-ui/react";
const baseStyleContainer = {
    border: 'none',
    _last: {}
};
const baseStyleButton = {
    transitionProperty: 'common',
    transitionDuration: 'normal',
    fontSize: '1rem',
    py: 2,
    px: 4,
    _focus: {
        border: 'none',
        boxShadow: 'none'
    },
    _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
    }
};
const baseStylePanel = {
    pt: 2,
    px: 4,
    pb: 5
};
const baseStyleIcon = {
    fontSize: '1.25em'
};
const faqVariant = (props)=>{
    const { colorScheme } = props;
    const color = `${colorScheme}.500`;
    const darkColor = colorScheme === 'neutral' ? `${colorScheme}.300` : color;
    const hoverStyle = {
        color,
        bg: 'transparent',
        _dark: {
            color: darkColor
        }
    };
    return {
        panel: {
            px: 0
        },
        button: {
            px: 0,
            _focusVisible: hoverStyle,
            _hover: hoverStyle
        }
    };
};
const defaultVariant = (props)=>{
    const { colorScheme: c } = props;
    const darkHoverBg = `${c}.${c === 'neutral' || c === 'gray' ? 800 : 900}`;
    const lightHoverBg = `${c}.${c === 'neutral' || c === 'gray' ? 100 : 50}`;
    return {
        panel: {
            px: 0
        },
        button: {
            px: 0,
            _focusVisible: {
                bg: lightHoverBg,
                _dark: {
                    bg: darkHoverBg
                }
            },
            _focus: {
                border: 'none',
                boxShadow: 'none'
            },
            _hover: {
                bg: lightHoverBg,
                _dark: {
                    bg: darkHoverBg
                }
            }
        }
    };
};
const baseStyle = {
    container: baseStyleContainer,
    button: baseStyleButton,
    panel: baseStylePanel,
    icon: baseStyleIcon
};
export const ThemedAccordion = {
    parts: parts.keys,
    baseStyle,
    variants: {
        faq: faqVariant,
        default: defaultVariant
    },
    defaultProps: {
        colorScheme: 'neutral',
        variant: 'default'
    }
};

//# sourceMappingURL=Accordion.js.map